// lib
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { call, delay } from 'redux-saga/effects'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export default function* cloneSaga(title) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const cloneURL = staticStore.urls.create
  if (!cloneURL) {
    throw new Error('No "create" endpoint URL (for cloning a portal)')
  }
  for (let i = 0; i < 5; i++) {
    try {
      const response = yield call(railsPostFetch, cloneURL, {
        body: JSON.stringify({
          origin_id: staticStore.dashboardID,
          name: title,
          patches: [{ path: ['blocks', 0, 'title'], value: title }]
        })
      })
      if (response.ok) {
        const body = yield call([response, 'json'])
        return body
      }
    } catch {
      if (i < 4) {
        yield delay(1500)
      }
    }
  }
  throw new Error('Error cloning portal after multiple attempts')
}
